// === RESET DES TUTORIELS ===
// Source unique pour effacer tous les flags localStorage qui marquent les
// tutoriels comme « déjà vus ». Au prochain passage dans la scène concernée,
// le tuto se relance comme à la première visite.
//
// Utilisé par :
//   - SettingsScene → "Réinitialiser la partie" (reset complet incluant tutos)
//   - BootScene     → bouton "Revoir les tutoriels"
//   - DevScene      → si besoin pour tester

import { TutorialOverlay } from '../ui/TutorialOverlay';

/** Clés localStorage de chaque tutoriel scène-spécifique. */
const TUTORIAL_KEYS = [
  'deadtide_combat_tuto_done',
  'deadtide_atelier_tuto_done',
  'deadtide_vigie_tutorial_seen',
  'deadtide_map_tuto_done',
  'deadtide_prep_tuto_done',
];

/**
 * Efface tous les flags de tutoriel. Au prochain passage dans la scène
 * concernée, le tuto se relancera. Sans effet sur les autres données du jeu.
 */
export function resetAllTutorials(): void {
  TutorialOverlay.reset();
  try {
    for (const key of TUTORIAL_KEYS) {
      localStorage.removeItem(key);
    }
  } catch {
    // localStorage indisponible — best-effort
  }
}

/** Liste des clés (exporté pour les tests). */
export function getTutorialKeys(): readonly string[] {
  return TUTORIAL_KEYS;
}
